import { useEffect, useState } from 'react';
import utils from '../../../utils/utils';
import useUserContext from '../../../hooks/useUserContext';
import useWebSocket from '../../../hooks/useWebSocket';

const WEBSOCKET_URL = process.env.REACT_APP_PW_SOCKET_WAGERS;

// Hook para manejar websockets de Kambi
export const useKambiWebsockets = () => {
  const { isLogged, updateUserBalance } = useUserContext();

  const [token, setToken] = useState(() => utils.getToken());

  useEffect(() => {
    if (isLogged) {
      setToken(utils.getToken());
    } else {
      setToken(null);
    }
  }, [isLogged]);

  // websocket
  const { readyState, webSocket, connect } = useWebSocket(WEBSOCKET_URL, {
    queryParams: { token },
  });

  // Reconectar websocket cuando cambie el token o el estado de login
  useEffect(() => {
    if (token && isLogged) {
      connect();
    }
  }, [token, isLogged, connect]);

  useEffect(() => {
    const onMessage = data => {
      const { balance, currency } = data;

      let userBalance = utils.getUserBalance();
      if (currency === 'real') {
        userBalance = { ...userBalance, balanceReal: balance };
        updateUserBalance(userBalance);
      }
    };

    if (readyState === 1 && utils.getUserInfo()) {
      webSocket.emit('subscribe', utils.getUserInfo().id);
      webSocket.on('wager:balance', onMessage);
    }
  }, [readyState]);
};
